import { call, put, takeEvery } from "redux-saga/effects";

// Chat Redux States
import { GET_CAMPAIGNS_LIST } from "./actionTypes";
import { hideCampaignsListLoader, setCampaignsList, showCampaignsListLoader } from "./actions";

import { getCampaignsList } from "../../../helpers/jwt_helper";
import { getErrorMessage, showErrorMessage } from "../../../helpers/utils";

function* onGetCampaignsList({payload: data}) {
  try {
    yield put(showCampaignsListLoader());
    // console.log(data);
    let response = yield call(getCampaignsList, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      client: data.client,
      search: data.search
    })
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({...i, created_at: new Date(i.created_at).toDateString()}))
    }
    yield put(setCampaignsList(response));
    yield put(hideCampaignsListLoader());
  } catch (error) {
    yield put(hideCampaignsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* campaignsListSaga() {
  yield takeEvery(GET_CAMPAIGNS_LIST, onGetCampaignsList);
}

export default campaignsListSaga;
